import React, { useContext, useState } from 'react'
import DetailsBox from '../../../../../components/Cards/DetailsBox'

//@MUI
import Box from '@mui/material/Box'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import VehiclesInvolved from './VehiclesInvolved'
import { FormControlLabel, Switch, Typography } from '@mui/material'
import { EventMetaContext } from '../../SingleEvent'
import FormPanel from './FormPanel'
import moment from 'moment'

const OpsPlan = ({ embedded = false }) => {
  const { eventMeta } = useContext(EventMetaContext)
  const [accordionOpen, setAccordionOpen] = useState(
    moment().isAfter(eventMeta.endDate) || eventMeta.EMPApproved ? false : true,
  )

  if (embedded) {
    return <FormPanel />
  }

  return (
    <Box border="solid 1px #39485e" borderRadius={1}>
      <Accordion disableGutters expanded={accordionOpen}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          onClick={() => setAccordionOpen(!accordionOpen)}
          sx={{
            display: 'flex',
          }}
        >
          <Typography variant="title3">Operational Plan</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormPanel />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default React.memo(OpsPlan)
